export function skipLinks() {
    (function() {
        /**
         * Skip Links Focus
         */
        $('.skip-link').on('click', function() {
            let target = $($(this).attr('href'));
            if (!target.length) {
                return;
            }

            // <nav> and <main> can't take focus on their own, so focus() is a
            // no-op until they're made programmatically focusable.
            if (!target.is('[tabindex]')) {
                target.attr('tabindex', '-1');
            }
            target.trigger('focus');
        });
    })();
}